import { useEffect, useRef } from 'react';

import { isFutureTime } from '@/utils';

// Tokens are typically valid for 1 hour - we have a 4-minute buffer
const DEFAULT_REFRESH_TIMEOUT = 56 * 60 * 1000;

const useAuthRefresh = (platform, auth, isAuthorized, skipInitialRefresh) => {
  const refreshTimerRef = useRef(null);

  const refresh = () => {
    if (!auth || !isAuthorized) return;

    auth.refresh();

    resetRefreshTimer();
  };

  const resetRefreshTimer = () => {
    if (refreshTimerRef.current) clearTimeout(refreshTimerRef.current);

    let timeout = DEFAULT_REFRESH_TIMEOUT;

    if (auth?.expiresAt && isFutureTime(auth?.expiresAt)) {
      timeout = auth.expiresAt - Date.now();
    }

    refreshTimerRef.current = setTimeout(refresh, timeout);
  };

  useEffect(() => {
    if (auth?.expiresAt) {
      resetRefreshTimer();
    }
  }, [auth?.expiresAt]);

  useEffect(() => {
    if (!auth || !isAuthorized) {
      clearTimeout(refreshTimerRef.current);

      return;
    }

    if (!skipInitialRefresh) {
      refresh();
    }

    return () => {
      clearTimeout(refreshTimerRef.current);
    };
  }, [platform, isAuthorized, skipInitialRefresh]);
};

export default useAuthRefresh;
